'use client';

import { useState, useEffect, useCallback } from 'react';
import { adminKycApi } from '../api';
import { KYCStatistics } from '../types';

interface UseKycStatsReturn {
  stats: KYCStatistics | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useKycStats(tenantSlug: string): UseKycStatsReturn {
  const [stats, setStats] = useState<KYCStatistics | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchStats = useCallback(async () => {
    if (!tenantSlug) return;

    try {
      setIsLoading(true);
      setError(null);
      const result = await adminKycApi.getKYCStats(tenantSlug);
      setStats(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch KYC stats'));
    } finally {
      setIsLoading(false);
    }
  }, [tenantSlug]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return {
    stats,
    isLoading,
    error,
    refetch: fetchStats,
  };
}
